import { render, staticRenderFns } from "./list-quiz.vue?vue&type=template&id=3a3f1968&scoped=true&"
import script from "./list-quiz.vue?vue&type=script&lang=js&"
export * from "./list-quiz.vue?vue&type=script&lang=js&"
import style0 from "./list-quiz.vue?vue&type=style&index=0&id=3a3f1968&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3f1968",
  null
  
)

export default component.exports